<template>
  <div :class="$style.alertController">
    <Alert
      v-for="alert in alerts"
      :key="alert.id"
      :delay="delay"
      :text="alert.message"
      :type="alert.type"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Alert from 'client/components/Alert/Alert.vue';

export default {
  name: 'AlertController',

  components: { Alert },

  computed: {
    delay() { return 7000; },
    ...mapState('AlertModule', [
      'alerts',
    ]),
  },
};
</script>

<style module>
@value (alertMessagesZIndex) from '~css/z-index.css';

:global(.messages),
.alertController {
  position: fixed;
  right: 0;
  top: 1rem;
  z-index: alertMessagesZIndex;
}
</style>
